export { iconSizes, IconSize } from './icon';
